import React from 'react';
import { cn } from '@/lib/utils';

interface GradientCardProps extends React.HTMLAttributes<HTMLElement> {
  as?: keyof JSX.IntrinsicElements;
  children: React.ReactNode;
  /** Tailwind opacity classes for the gradient overlay. Default 60/30. */
  overlayOpacity?: string;
}

/**
 * Card surface that paints a soft gradient image behind its contents.
 * Paints the shared `.brand-gradient` wash, which is built from the
 * workspace's own brand colors and flips with the theme on its own.
 * Content is rendered above the gradient via a relatively positioned wrapper.
 */
const GradientCard: React.FC<GradientCardProps> = ({
  as = 'section',
  children,
  className = '',
  overlayOpacity = 'opacity-60 dark:opacity-40',
  ...rest
}) => {
  const Tag = as as 'section';
  return (
    <Tag
      {...rest}
      className={cn(
        'relative overflow-hidden rounded-2xl border border-border-primary bg-surface-primary shadow-md',
        className
      )}
    >
      <div aria-hidden className="pointer-events-none absolute inset-0">
        <div className={`brand-gradient absolute inset-0 ${overlayOpacity}`} />
      </div>
      <div className="relative">{children}</div>
    </Tag>
  );
};

export default GradientCard;
